import { NavLink } from 'react-router-dom'

import { useT } from '@/i18n'
import type { MessageKey } from '@/i18n'
import { cn } from '@/lib/cn'

const tabs: { to: string; label: MessageKey; end?: boolean }[] = [
  { to: '', label: 'profile.tabPosts', end: true },
  { to: 'with_replies', label: 'profile.tabReplies' },
  { to: 'media', label: 'profile.tabMedia' },
  { to: 'likes', label: 'profile.tabLikes' },
]

export function ProfileTabs({ username }: { username: string }) {
  const t = useT()
  return (
    <nav className="flex border-b border-line" aria-label={t('profile.tabsLabel')}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.label}
          to={`/${username}${tab.to ? `/${tab.to}` : ''}`}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'relative flex-1 px-2 py-4 text-center text-[15px] font-medium transition-colors',
              'hover:bg-surface-hover',
              isActive ? 'font-bold text-ink' : 'text-ink-muted',
            )
          }
        >
          {({ isActive }) => (
            <>
              {t(tab.label)}
              {isActive && (
                <span className="absolute inset-x-0 bottom-0 mx-auto h-1 w-14 bg-brand-ink" />
              )}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
